import React from 'react'
import { SubscriptionPackage } from '../../apis/subscriptionApi'
import './subscriptionSelector.css'
import ToggleContent from '../ToggleContent'
import CardButton from '../CardButton'
import { i18n } from '../../i18n/i18n'

interface Props {
    subscriptions: SubscriptionPackage[];
    selectedSubscriptionId: number | null;
    onSelectSubscription: (subscriptionId: number, amount: number) => void;
    onDowngrade: (planId: number) => void;
    onUpgrade: (planId: number) => void;
    currentPurchasePlan: SubscriptionPackage | null;
    handleReactivateSubscription: () => void;
    handleCancelSubscription: () => void;
}

const planRank: Record<string, number> = {
  free: 1,
  starter: 2,
  advanced: 3,
  custom: 4
}

const SubscriptionSelector: React.FC<Props> = ({
  subscriptions,
  selectedSubscriptionId,
  onSelectSubscription,
  onDowngrade,
  onUpgrade,
  currentPurchasePlan,
  handleReactivateSubscription,
  handleCancelSubscription
}) => {
  const currentPlan = subscriptions.find(s => s.is_current_plan)
  const currentRank = currentPlan ? planRank[currentPlan.slug] : 1

  if (!subscriptions || subscriptions.length === 0 || !currentPurchasePlan) return null

  return (
        <div>
            <br/>
            <strong><h2>{i18n('Select a Subscription')}</h2></strong>
            <br/>

            <div className="subscription-container">
                {subscriptions.filter(s => planRank[s.slug]).map(subscription => {
                  const isSelected = selectedSubscriptionId === subscription.id
                  const targetRank = planRank[subscription.slug]

                  const isCurrent = subscription.is_current_plan
                  const isFreePlan = subscription.slug === 'free'

                  const canUpgrade = targetRank > currentRank && subscription.slug !== 'custom'
                  const canDowngrade = targetRank < currentRank
                  const currentIsSubscribed = currentPlan?.is_subscribed === true

                  const upcoming = currentPurchasePlan?.scheduled_downgrade?.plan_id == subscription.id
                    ? currentPurchasePlan.scheduled_downgrade
                    : null

                  return (
                        <div
                            key={subscription.id}
                            className={`subscription-card ${
                                isCurrent ? 'active' : isSelected ? 'selected' : ''
                            }`}

                            onClick={() => {
                              onSelectSubscription(subscription.id, Number(subscription.price))

                              if (subscription.slug === 'custom') {
                                window.location.href = `mailto:${currentPurchasePlan.email}`
                              }
                            }}

                        >
                            <div>
                                <div className="flex items-start gap-2">
                                    <h3 className="subscription-name">

                                        {subscription?.slug === 'free'
                                          ? i18n('Free - Exploring Label Designer')
                                          : subscription?.slug === 'starter'
                                            ? i18n('Starter - Small and Growing Users')
                                            : subscription?.slug === 'advanced'
                                              ? i18n('Advanced - Operations Teams')
                                              : i18n('Custom (QPRO+) - Integrated Enterprise From $99 / month')
                                        }

                                    </h3>
                                    {isCurrent &&
                                        <span
                                            className="bg-green-500 text-white px-2 py-0.5 text-xs">{i18n('Active')}</span>}
                                </div>
                                <ToggleContent
                                    title={i18n('Features included')}
                                    slug={subscription.slug}
                                />
                                <br/>
                                {/*<p className="subscription-price">{i18n('Price')}: ${subscription.price}</p>*/}
                            </div>

                            {!isCurrent && (
                                <div className="flex justify-end gap-2 mt-4">
                                    {!upcoming && canDowngrade && (
                                        <CardButton
                                            proceedText="Downgrade"
                                            onProceedClick={() => onDowngrade(subscription.id)}
                                        />
                                    )}
                                    {currentIsSubscribed && canUpgrade && (
                                        <CardButton proceedText="Upgrade"
                                                    onProceedClick={() => onUpgrade(subscription.id)}/>
                                    )}
                                </div>
                            )}
                            {isCurrent && (
                                <div className="flex justify-end gap-2 mt-4">
                                    {currentPurchasePlan.ends_on
                                      ? (
                                            <CardButton
                                                proceedText="Reactivate"
                                                onProceedClick={handleReactivateSubscription}
                                            />
                                        )
                                      : currentPurchasePlan.is_subscribed && !isFreePlan
                                        ? (
                                                <CardButton
                                                    proceedText="Cancel"
                                                    onProceedClick={handleCancelSubscription}
                                                />
                                          )
                                        : null}
                                </div>
                            )}
                        </div>
                  )
                })}
            </div>
        </div>
  )
}

export default SubscriptionSelector
